import { defineMessages } from 'react-intl-next';

export default defineMessages({
	editSite: {
		id: 'hub-app-shell.avatar-menu.edit-site',
		defaultMessage: 'Edit site',
		description: 'Edit the customer hub',
	},
	profile: {
		id: 'hub-app-shell.avatar-menu.profile',
		defaultMessage: 'Profile',
		description: 'Profile for the user',
	},
	logout: {
		id: 'hub-app-shell.avatar-menu.logout',
		defaultMessage: 'Logout',
		description: 'Logout for the user',
	},
});
